import {
  DRIVERS_RANKING_POINTS,
  DRIVERS_RANKING_FREE_PRACTICE_RESULTS,
  DRIVERS_RANKING_QUALIFYING_RESULTS,
  DRIVERS_RANKING_RACE_STARTING_GRID,
  DRIVERS_RANKING_RACE_RESULTS,
  DriversRankingVariants,
} from '../typings/drivers-ranking';
import {
  RaceSessionStatus,
  RACE_STATUS_PLAYED,
  RACE_STATUS_FIXTURE,
  RACE_STATUS_PLAYING,
} from '../typings/race-session';

export const isFreePracticePhase = (phase: DriversRankingVariants) => phase === DRIVERS_RANKING_FREE_PRACTICE_RESULTS;

export const isQualifyingPhase = (phase: DriversRankingVariants) => phase === DRIVERS_RANKING_QUALIFYING_RESULTS;

export const isRacePhase = (phase: DriversRankingVariants) => phase === DRIVERS_RANKING_RACE_RESULTS;

export const isRankingPoints = (phase: DriversRankingVariants) => phase === DRIVERS_RANKING_POINTS;

export const isStartingGrid = (phase: DriversRankingVariants) => phase === DRIVERS_RANKING_RACE_STARTING_GRID;

export const showlastGrandPrixUpdate = (phase: DriversRankingVariants) => isRankingPoints(phase);

export const showBestLapUpdate = (phase: DriversRankingVariants) => isRacePhase(phase);

// Check RaceSessionStatus
export const isPlayed = (sessionStatus: RaceSessionStatus) => sessionStatus === RACE_STATUS_PLAYED;

export const isFixture = (sessionStatus: RaceSessionStatus) => sessionStatus === RACE_STATUS_FIXTURE;

export const isPlaying = (sessionStatus: RaceSessionStatus | undefined) => sessionStatus === RACE_STATUS_PLAYING;
